import { TwentyFourHourContent } from './PSPContents/24-Hour';
import { ClimateControlledContent } from './PSPContents/ClimateControlledContent';
import { DriveUpContent } from './PSPContents/DriveUpContent';
import { CarStorageContent } from './PSPContents/CarStorageContent';
import { RvStorageContent } from './PSPContents/RvStorageContent';
import { WineContent } from './PSPContents/WineContent';
import { PortableStorageContent } from './PSPContents/PortableStorageContent';
import { ElectricityContent } from './PSPContents/ElectricityContent';
import { MilitaryContent } from './PSPContents/MilitaryContent';
import { CollegeContent } from './PSPContents/CollegeContent';
import { CommercialContent } from './PSPContents/CommercialContent';
import { BoatContent } from './PSPContents/BoatContent';
import { ATVContent } from './PSPContents/ATVContent';
import { BicycleContent } from './PSPContents/BicycleContent';
import { DirtBikeContent } from './PSPContents/DirtBikeContent';
import { GolfCartContent } from './PSPContents/GolfCartContent';
import { MotorcycleStorageContent } from './PSPContents/MotorcycleStorageContent';
import { JetskiContent } from './PSPContents/JetskiContent';
import { KayakContent } from './PSPContents/KayakContent';
import { SelfStorageContent } from './PSPContents/SelfStorageContent';
import { TruckContent } from './PSPContents/TruckContent';
import { VehicleContent } from './PSPContents/VehicleContent';
import { MiniSelfStorageContent } from 'pages/SGPPage/SGPContents/MiniSelfStorageContent';
import { MediumSelfStorageContent } from 'pages/SGPPage/SGPContents/MediumSelfStorageContent';
import { LockerStorageContent } from 'pages/SGPPage/SGPContents/LockerStorageContent';
import { SmallSelfStorageContent } from 'pages/SGPPage/SGPContents/SmallSelfStorageContent';
import { LargeSelfStorageContent } from 'pages/SGPPage/SGPContents/LargeSelfStorageContent';

// Content map for PSP and SGP page types.
// SGP pages share the same module factory infrastructure (PSPModuleFactory)
// but are distinguished by pageType in their content definitions.
const PSPContentMap = {
	// psp - pages
	'24-hour': TwentyFourHourContent,
	'climate-controlled': ClimateControlledContent,
	wine: WineContent,
	portable: PortableStorageContent,
	electricity: ElectricityContent,
	'drive-up': DriveUpContent,
	student: CollegeContent,
	commercial: CommercialContent,
	military: MilitaryContent,
	boat: BoatContent,
	'dirt-bike': DirtBikeContent,
	'golf-cart': GolfCartContent,
	atv: ATVContent,
	bike: BicycleContent,
	car: CarStorageContent,
	motorcycle: MotorcycleStorageContent,
	'jet-ski': JetskiContent,
	kayak: KayakContent,
	'what-is': SelfStorageContent,
	rv: RvStorageContent,
	truck: TruckContent,
	vehicle: VehicleContent,

	// sgp - pages
	'mini-self-storage': MiniSelfStorageContent,
	'medium-self-storage': MediumSelfStorageContent,
	'self-storage-lockers': LockerStorageContent,
	'small-self-storage': SmallSelfStorageContent,
	'large-self-storage': LargeSelfStorageContent,
};

export const normalizeKeyword = (keyword) => {
	if (typeof keyword !== 'string') {
		return '';
	}

	let normalizedKeyword = keyword
		.trim()
		.toLowerCase()
		.replace(/\.html$/, '')
		.replace(/\/$/, '');

	// Handle special cases after normalization
	if (
		normalizedKeyword === 'with-electricity' ||
		normalizedKeyword === 'self-storage-with-electricity'
	) {
		normalizedKeyword = 'electricity';
	} else if (
		normalizedKeyword === 'for-boats' ||
		normalizedKeyword === 'self-storage-for-boats'
	) {
		normalizedKeyword = 'boat';
	}

	return normalizedKeyword;
};

/**
 * Get PSP content synchronously for server-side rendering
 * @param {string} keyword - The keyword from the URL
 * @returns {Object|null} The content object or null if not found
 */
export function getPSPContent(keyword) {
	if (!keyword) {
		return null;
	}
	const normalizedKeyword = normalizeKeyword(keyword);
	return PSPContentMap[normalizedKeyword] || null;
}

/**
 * Check if a keyword has corresponding PSP content
 * @param {string} keyword - The keyword to check
 * @returns {boolean} True if the keyword has content
 */
export function hasPSPContentSSR(keyword) {
	const resolvedKeyword = normalizeKeyword(keyword);
	return Boolean(
		resolvedKeyword &&
		Object.prototype.hasOwnProperty.call(PSPContentMap, resolvedKeyword),
	);
}

export default PSPContentMap;
